/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_2_LabelInputs */

const en_landing_guide_stat_2_label = /** @type {(inputs: Landing_Guide_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largest edit source shown by Ideogram`)
};

const zh_landing_guide_stat_2_label = /** @type {(inputs: Landing_Guide_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 展示的最大编辑源图`)
};

/**
* | output |
* | --- |
* | "Largest edit source shown by Ideogram" |
*
* @param {Landing_Guide_Stat_2_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_2_label = /** @type {((inputs?: Landing_Guide_Stat_2_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_2_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_2_label(inputs)
	return zh_landing_guide_stat_2_label(inputs)
});
export { landing_guide_stat_2_label as "landing.guide.stat_2_label" }